// @ts-nocheck

export interface ISearchAiFeedbackRequestDto {
    threadId: string;
    messageId?: string;
    rating: RatingEnum;
    feedbackComment?: string;
}
export enum RatingEnum {
    POSITIVE = 'positive',
    NEGATIVE = 'negative'
}

